import React, { FC } from 'react';
import { WarningAmberOutlined } from '@mui/icons-material';
import styles from './suspension-banner.module.css';

interface SuspensionBannerProps {
  message: string;
  endDate?: string;
}

const formatDate = (dateStr: string): string => {
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
};

export const SuspensionBanner: FC<SuspensionBannerProps> = ({ message, endDate }) => {
  return (
    <div className={styles.banner} role="alert">
      <WarningAmberOutlined className={styles.icon} fontSize="small" />
      <div className={styles.content}>
        <p className={styles.title}>Serviço suspenso</p>
        {message && <p className={styles.message}>{message}</p>}
        {endDate && (
          <p className={styles.returnDate}>
            Previsão de retorno:{' '}
            <span className={styles.returnDateValue}>{formatDate(endDate)}</span>
          </p>
        )}
      </div>
    </div>
  );
};
